// extracted by mini-css-extract-plugin
module.exports = {"selectContentWrapper":"FileTypeSelect_selectContentWrapper__2cG80","label":"FileTypeSelect_label__c6aFC"};